import { ProgramAvailablity } from "src/enums";
import { ProgramInfo } from "src/models";
import { ProgramDetail, ProgramDetailInitialState, ReduxAction } from "../models";
import { ProgramViewTypes } from "../types";

export const ProgramViewState = (state: ProgramDetail = ProgramDetailInitialState, action?: ReduxAction): ProgramDetail => {
    if (!action) return state;

    switch (action.type) {

        case ProgramViewTypes.SHOW_PROGRAM_VIEW_LOADING:
            return { ...state, loading: true, ipChecking: false };
        case ProgramViewTypes.HIDE_PROGRAM_VIEW_LOADING:
            return { ...state, loading: false, ipChecking: false };
        case ProgramViewTypes.CLEAR_PROGRAM_VIEW_INFO:
            return { ...ProgramDetailInitialState, message: { ...ProgramDetailInitialState.message } };
        case ProgramViewTypes.REQUEST_PROGRAM_VIEW_INFO:
            return { ...ProgramDetailInitialState, message: { ...ProgramDetailInitialState.message }, loading: true, ipChecking: false };
        case ProgramViewTypes.SET_PROGRAM_VIEW_STATUS:
            return { ...state, availability: action.payload, ipChecking: false };
        case ProgramViewTypes.SET_PROGRAM_MESSAGE:
            return { ...state, message: action.payload, ipChecking: false };
        case ProgramViewTypes.CLEAR_PROGRAM_MESSAGE:
            return { ...state, message: { hasMessage: false }, ipChecking: false };
        case ProgramViewTypes.SET_PROGRAM_PLAYER_DATA:
            return { ...state, ipChecking: false, player: action.payload, loading: false, availability: ProgramAvailablity.Available, killSessionId: action.payload ? [] : state.killSessionId };
        case ProgramViewTypes.CLEAR_PROGRAM_PLAYER_DATA:
            return { ...state, player: undefined, killSessionId: [], ipChecking: false };
        case ProgramViewTypes.SET_CURRENT_STREAM:
            return { ...state, currentStream: action.payload, message: { ...ProgramDetailInitialState.message }, ipChecking: false };
        case ProgramViewTypes.SET_PROGRAM_VIEW_INFO:

            const payload: ProgramInfo | undefined = action.payload;

            if (!payload)
                return { ...state, loading: false, info: undefined, currentStream: undefined, availability: ProgramAvailablity.NotFound };

            const currentStream = payload.streams.find((x) => !x.lock);

            return { ...state, ipChecking: false, loading: false, info: { ...payload }, currentStream: currentStream ? { ...currentStream } : undefined };

        case ProgramViewTypes.START_PLAYBACK_REPORTING:
            return { ...state, reporting: true };
        case ProgramViewTypes.STOP_PLAYBACK_REPORTING:
            return { ...state, reporting: false };
        case ProgramViewTypes.SET_OTHER_SESSIONS:
            return { ...state, killSessionId: action.payload };
        case ProgramViewTypes.DECREASE_REAMININ_TIME:
            if (!state.info) return state;
            const diff = Math.floor((new Date().getTime() - state.info.fetchTime) / 1000);
            let time = state.info.calculatedRemainingToStart > 0 ? state.info.remainingToStart - diff : 0;
            time = Math.max(time, 0);
            return { ...state, info: { ...state.info, calculatedRemainingToStart: time } };

        case ProgramViewTypes.CHECK_FORBIDDEN_IP:
            return { ...state, ipChecking: true };
        case ProgramViewTypes.FORBIDDEN_IP_CHECKED:
            return {
                ...state, ipChecking: false,
                availability: action.payload?.succeed ? ProgramAvailablity.ForbidenNoButton : state.availability,
                message: { ...state.message, message: action.payload?.succeed ? action.payload?.message : state.message.message }
            };
        case ProgramViewTypes.TOGGLE_ECONOMIC:
            if (!state.info) return state;
            return {
                ...state,
                info: {
                    ...state.info,
                    qualityConfig: {
                        ...state.info?.qualityConfig,
                        hqEnabled: action.payload
                    }
                }
            };
        case ProgramViewTypes.SET_PROMOTION:
            return { ...state, promotion: action.payload };
    }

    return state;
};